// ============================================================
// 财务端接口（cs8 独立应用 app/finance，URL 形如 /finance/<action>）
// 对接图谱 §九 / §十五；P66 起 19 条动作（+回款计划 +通用单据详情）
// 说明：复用 util/request（baseURL=cs8 API，头 token + enterprise）
// ============================================================
import request from '../util/request'

const APP = '/finance/'

function post(url, data) {
  return request({
    url: APP + url,
    method: 'post',
    data: data || {}
  })
}
function get(url, params) {
  return request({
    url: APP + url,
    method: 'get',
    params: params || {}
  })
}

// ---- 账号画像 ----
export function financeMyProfile(data) {
  return get('myProfile', data)
}

// ---- 待办 + 审批 ----
export function financeTodoList(data) {
  return post('todoList', data)
}

/* 【P214】站内消息：数据源 t_saas_data_message（与 todoList 的审批单表分离） */
export function financeMsgList(data) { return post('msgList', data) }
/* 【P251】财务端消息已读：只标记已读，**不代替审批** */
export function financeMsgReadAll(data) { return post('msgReadAll', data || {}) }
export function financeMsgReadBatch(data) { return post('msgReadBatch', data) }
/* 【P301 全站消息统一】「全部」Tab 的批量删除（财务端原先没有该接口） */
export function financeMsgDeleteBatch(data) { return post('msgDeleteBatch', data) }
// 【P78】待我审批数量（底栏/快捷入口气泡用；已注册路由 todoStat）
/* 【P116】销售人员池（支付单/开票/退款 三个列表的销售人员筛选） */
export function financeSalesPool(data) {
  return post('salesPool', data)
}
export function financeTodoStat(data) {
  return post('todoStat', data)
}
export function financeApprovalHistory(data) {
  return post('approvalHistory', data)
}
export function financeApprovalDetail(data) {
  return get('approvalDetail', data)
}
// 通过 / 驳回（写链路）：后端要求 action 语义，成功返回 { ok, code, msg, desc, biz, ... }
export function financeApprovalApprove(data) {
  return post('approvalApprove', data)
}
export function financeApprovalReject(data) {
  return post('approvalReject', data)
}

// ---- 财务四表 ----
export function financePaymentsList(data) {
  return post('paymentsList', data)
}
export function financeRefundsList(data) {
  return post('refundsList', data)
}
export function financeInvoicesList(data) {
  return post('invoicesList', data)
}
export function financeTransactionRecordsList(data) {
  return post('transactionRecordsList', data)
}
// 【P66】回款计划（t_pro_orders_payment_plan）
export function financePaymentPlansList(data) {
  return post('paymentPlansList', data)
}

// 【P66】通用单据详情：type ∈ payment|refund|invoice|plan|sellContract|
//        financeContract|purchase|room|valueAdded|balance，sn = 单据 sn
// 返回 { type, title, document, groups:[{name, fields:[{label,value,raw}]}] }
export function financeDocDetail(type, sn) {
  return get('docDetail', { type: type, sn: sn })
}

/* 【P207】财务端「添加备注」：biz = payment / refund / invoice + sn + remark */
export function financeSaveDocRemark(data) {
  return post('saveDocRemark', data)
}

// ---- 合同与订单 ----
export function financeContractsList(data) {
  return post('contractsList', data)
}
export function financePurchaseContractsList(data) {
  return post('purchaseContractsList', data)
}
export function financeSellOrdersList(data) {
  return post('sellOrdersList', data)
}
export function financeRoomOrdersList(data) {
  return post('roomOrdersList', data)
}
export function financeValueAddedOrdersList(data) {
  return post('valueAddedOrdersList', data)
}
export function financeAfterSalesOrdersList(data) {
  return post('afterSalesOrdersList', data)
}

// ---- 统计 ----
export function financeStatisticsDashboard(data) {
  return get('statisticsDashboard', data)
}

// ---- 【P187】筛选选择器数据源 + 全量合计 ----
// 关联单号选择器：kind ∈ customer | opportunity | sales_contract | finance_contract
//   返回 { list: [{ value, text, sub }] }（value = sn，sub = 编号/备注）
export function financeFilterRefOptions(data) {
  return post('filterRefOptions', data)
}
// 门店选择器（会议室订单 / 增值订单的门店维度；二级联动的「一级」）
export function financeStoresOptions(data) {
  return post('storesOptions', data)
}
// 会议室选择器（可传 stores_sn 过滤，实现门店↔会议室二级联动）
export function financeRoomsOptions(data) {
  return post('roomsOptions', data)
}
// 全量合计：list ∈ room | payments | invoices | refunds | valueAdded
//   口径 = 当前筛选条件下的全量（服务端 count + sum），与已加载页数无关
//   返回 { list, total, amount, amount_field }
export function financeListSum(data) {
  return post('listSum', data)
}



// WEBPACK FOOTER //
// ./src/api/finance.js